import { render, staticRenderFns } from "./act-statistics.vue?vue&type=template&id=bfb0c60c&"
import script from "./act-statistics.vue?vue&type=script&lang=ts&"
export * from "./act-statistics.vue?vue&type=script&lang=ts&"
import style0 from "./act-statistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports